import { render, staticRenderFns } from "./ElButtonAtsisiusti.vue?vue&type=template&id=ca6f9f52&scoped=true&"
import script from "./ElButtonAtsisiusti.vue?vue&type=script&lang=js&"
export * from "./ElButtonAtsisiusti.vue?vue&type=script&lang=js&"
import style0 from "./ElButtonAtsisiusti.vue?vue&type=style&index=0&id=ca6f9f52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca6f9f52",
  null
  
)

export default component.exports